export const NOT_FOUND = 'No matches were found';
export const apiLocation = (window as Record<string, any>)['REACT_APP_API'];

